import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import axios from "axios";
import {
  BreadcrumsIcon,
  CancelIcon,
  DashBoardIcon,
  DownFilterDown,
  LeftArrow,
  MyDashBoardIcon,
  RightArrow,
  SearchesCIcon,
  SortIcon,
} from "../../SvgIconsData";
import Skeleton from "@mui/material/Skeleton";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { AZIcon, OldSortIcon, SideArrow, ZAIcon } from "../../assets/icons/iconshere";
import { useNavigate } from "react-router-dom";
import CoursesCard from "./user/courses/CoursesCard";
import OnLoadSection from "./user/OnLoadSection";
import { findAllCategoryIds, findCategoryOption } from "../../utils";

const { innerWidth: width, innerHeight: height } = window;
const scrollAmount = 100;
const body = document.body;

const sortingOptions = {
  1: { icon: <SortIcon />, label: "Latest" },
  2: { icon: <OldSortIcon />, label: "Oldest" },
  3: { icon: <AZIcon />, label: "A to Z" },
  4: { icon: <ZAIcon />, label: "Z to A" },
};

const sortOptions = [
  { label: "Latest", value: (b, c) => new Date(c.createdAt) - new Date(b.createdAt), type: 1 },
  { label: "Oldest", value: (b, c) => new Date(b.createdAt) - new Date(c.createdAt), type: 2 },
  { label: "A to Z", value: (b, c) => b.name.localeCompare(c.name), type: 3 },
  { label: "Z to A", value: (b, c) => c.name.localeCompare(b.name), type: 4 },
];

const ExploreCourses = ({ courseSize }) => {
  const containerRef = useRef();
  const parentRef = useRef();
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const appData = useSelector((state) => state.applicationSlice);
  const isLoggedIn = userData.token.length > 0 ? true : false;
  const navigate = useNavigate();
  const [exploreList, setExploreList] = useState([]);
  const [optionList, setOptionList] = useState([]);
  const [searchXRModule, setSearchXRModule] = useState("");
  const [searchFilter, setSearchFilter] = useState("");
  const [showFilterId, setShowFilterId] = useState(null);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [selectedCategoryCheckboxes, setSelectedCategoryCheckboxes] = useState([]);
  const [selectedQuickCheckboxes, setSelectedQuickCheckboxes] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showWalkThroughVideo, setShowWalkThroughVideo] = useState(false);
  const [categoryList, setCategoryList] = useState(null);
  const [showTour, setShowTour] = useState(false);
  const [showEndVideo, setShowEndVideo] = useState(false);
  const [cateLoading, setCateLoading] = useState(false);
  const [sorting, setSorting] = useState({
    value: (b, c) => new Date(c.createdAt) - new Date(b.createdAt),
    type: 1,
  });

  useEffect(() => {
    setCategoryList(appData?.categoryList?.data || null);
    setOptionList(appData?.tags?.data?.children?.filter((e) => e.name != "Sectors") || []);
  }, [appData?.categoryList]);

  useEffect(() => {
    setShowWalkThroughVideo(!!configData?.config?.walkThroughVideo);
  }, [configData]);

  const shouldScroll =
    parentRef.current &&
    containerRef.current &&
    (containerRef.current.clientWidth / parentRef.current.clientWidth) * 100 > 90;

  const openFilter = (id) => {
    setShowFilterId(showFilterId == id ? null : id);
  };

  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleScroll = (scrollDirection) => {
    const container = containerRef.current;
    if (container) {
      const currentScrollLeft = container.scrollLeft;

      if (scrollDirection === "left") {
        container.scrollTo({
          left: currentScrollLeft - scrollAmount,
          behavior: "smooth",
        });
      } else if (scrollDirection === "right") {
        container.scrollTo({
          left: currentScrollLeft + scrollAmount,
          behavior: "smooth",
        });
      }
    }
  };

  const getExploreModuleList = async () => {
    try {
      const { data } = await axios.get(`${configData.config.API_URL}/api/module/all/${configData.config.MODE}`, {
        params: { ...courseSize, applicationId : configData.config.applicationId },
        headers: {
          Authorization: `Bearer`,
        },
      });
      setExploreList(data.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getExploreModuleList();
  }, [isLoggedIn]);

  const handleCheckboxChange = (e) => {
    const updatedCheckboxes = [...selectedCheckboxes];
    const indexOfObject = updatedCheckboxes.findIndex((item) => item.id === e.id);
    if (indexOfObject === -1) {
      updatedCheckboxes.push(e);
    } else {
      updatedCheckboxes.splice(indexOfObject, 1);
    }

    setSelectedCheckboxes(updatedCheckboxes);
  };

  const quickSelect = (value) => {
    const updatedCheckboxes = [...selectedQuickCheckboxes];
    for (let i = 0; i < value.id.length; i++) {
      let tagId = value.id[i];
      const indexOfObject = updatedCheckboxes.findIndex((item) => item.id === tagId);
      if (indexOfObject === -1) {
        updatedCheckboxes.push({ id: tagId, name: value.name });
      } else {
        updatedCheckboxes.splice(indexOfObject, 1);
      }
    }
    setSelectedQuickCheckboxes(updatedCheckboxes);
  };

  const handleCancelTag = (item) => {
    setSelectedCheckboxes((prevSelected) => prevSelected.filter((selectedItem) => selectedItem !== item));
  };

  const resetFilter = () => {
    setSelectedCheckboxes([]);
    setSelectedCategoryCheckboxes([]);
    setSearchFilter("");
  };

  const filterCourses = (e) => {
    if (searchXRModule.length && !e.name.toLowerCase().includes(searchXRModule.toLowerCase())) return false;
    const tags = e.tags.map((e) => e.id);
    const tagCategory = e.tagCategory.map((e) => e.id);

    if (selectedCheckboxes.length && !selectedCheckboxes.every((element) => tags.includes(element.id))) return false;
    if (selectedQuickCheckboxes.length && !selectedQuickCheckboxes.every((element) => tags.includes(element.id)))
      return false;
    if (
      selectedCategoryCheckboxes.length &&
      !selectedCategoryCheckboxes.some((checkbox) => tagCategory.includes(checkbox.id))
    )
      return false;

    return true;
  };

  useEffect(() => {
    if (showWalkThroughVideo) {
      const isTourCompleted = localStorage.getItem("tour");
      if (isTourCompleted) {
        setShowTour(false);
        body.classList.remove("filter-active");
      } else {
        setShowTour(true);
        body.classList.add("filter-active");
      }
    }
    return () => {
      body.classList.remove("filter-active");
    };
  }, [showWalkThroughVideo]);

  const toggleExpand = (item) => {
    setCateLoading(true);
    let find = categoryList.children.find((e) => e.id == item.id);
    setCategoryList(find || null);
    setCateLoading(false);
  };

  useEffect(() => {
    const messageListener = (event) => {
      if (event.data === "endPlayer") {
        setShowEndVideo(true);
      }
    };
    window.addEventListener("message", messageListener);
    return () => {
      window.removeEventListener("message", messageListener);
    };
  }, []);

  const searchCategory = (ID, category) => {
    if (category.id === ID) return category;
    if (category.children && category.children.length > 0) {
      for (const child of category.children) {
        const result = searchCategory(ID, child);
        if (result) return result;
      }
    }
    return null;
  };

  const handleBackCategory = (id) => {
    setCateLoading(true);
    const result = searchCategory(id, appData?.categoryList?.data);
    setCategoryList(result || null);
    setCateLoading(false);
  };

  const handleSelectCategory = (category, isChecked) => {
    let selectedIds= [...selectedCategoryCheckboxes]; 
    let findCategory = findCategoryOption(categoryList, category.id);
    let allChildrenCategoryIds = findAllCategoryIds(findCategory);

    const updateIds = (oldIds, newIds, addNewIds) => {
      const existingIds = new Set(oldIds.map(item => item.id));

      if (addNewIds) {
          const uniqueNewIds = newIds.filter(item => !existingIds.has(item.id));
          return [...oldIds, ...uniqueNewIds];
      } else {
          const filteredOldIds = oldIds.filter(item => !newIds.some(newItem => newItem.id === item.id));
          return filteredOldIds;
      }
  };
  
    let allIdsList = updateIds(selectedIds, allChildrenCategoryIds, !isChecked);
    setSelectedCategoryCheckboxes([...allIdsList]);

    // setSelectedCategoryCheckboxes((prev) => {
    //   const exists = prev.some((e) => e.id === category.id);
    //   if (exists) {
    //     return prev.filter((e) => e.id !== category.id);
    //   } else {
    //     return [...prev, category];
    //   }
    // });



  };

  const getSelectedCount = (filterId) => {
    const selectedCount = selectedCheckboxes.filter((item) => {
      const filter = optionList.find((filter) => filter.id === filterId);
      return filter.tags.some((tag) => tag.id === item.id);
    }).length;

    return selectedCount > 9 ? "9+" : selectedCount.toString();
  };

  const renderCount = (filterId) => {
    const count = getSelectedCount(filterId);
    return count !== "0" ? <span className="count">{count}</span> : null;
  };

  let exploreFilteredList = exploreList.filter(filterCourses).sort(sorting.value);
  return (
    <>
      <div className="explore-courses">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="Breadcrums">
                <span onClick={isLoggedIn ? () => navigate(`/dashboard/${userData.user.uuid}`) : null}> Home </span>
                <span className="active">
                  <BreadcrumsIcon /> Explore
                </span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-9">
              <p className="page-title">
                Explore <span> XR Modules </span>
              </p>
            </div>

            <div className="col-3 px-4 d-flex align-items-center justify-content-end">
              <Dropdown show={dropdownOpen} onToggle={handleDropdownToggle}>
                <Dropdown.Toggle id="dropdown-basic" className="exploresort">
                  <span className="arrow">
                    {sortingOptions[sorting.type].icon} {sortingOptions[sorting.type].label}
                  </span>
                  <DownFilterDown />
                </Dropdown.Toggle>
                <Dropdown.Menu className=" sort">
                  <div className="sort-options">
                    {sortOptions.map((option) => (
                      <p
                        key={option.type}
                        className={sorting.type === option.type ? "active" : ""}
                        onClick={() => {
                          setSorting({ value: option.value, type: option.type });
                          setDropdownOpen(false);
                        }}
                      >
                        {option.label}
                      </p>
                    ))}
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="col-3 mt-2">
              <div className="filter-side">
                <form className=" app-search app-search1 d-flex justify-content-start ">
                  <div className="position-relative w-100">
                    <SearchesCIcon />
                    {searchXRModule.length > 0 && (
                      <span className="searchiconcancel" onClick={() => setSearchXRModule("")}>
                        <CancelIcon />
                      </span>
                    )}

                    <input
                      type="text"
                      name="searchName"
                      className="form-control"
                      placeholder="Search XR Modules"
                      autoComplete="off"
                      value={searchXRModule}
                      onChange={(e) => setSearchXRModule(e.target.value)}
                    />
                  </div>
                </form>

                <div className="filter-box">
                  <div className="filter-item">
                    <span
                      className={`filter-head ${showFilterId == "categoryOpen" ? "active" : ""}`}
                      onClick={(e) => openFilter("categoryOpen")}
                    >
                      <span className="arrow for-cate">
                        {categoryList?.id == configData?.config?.categoryFilterId && <MyDashBoardIcon />}

                        {categoryList && categoryList?.id != configData?.config?.categoryFilterId && (
                          <span
                            className="cate-back"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleBackCategory(categoryList.parentId);
                            }}
                          >
                            <SideArrow />
                          </span>
                        )}
                        <span className="d-flex align-items-center justify-content-start gap-2">
                          {categoryList?.name || "Categories"}
                          {selectedCategoryCheckboxes.length > 0 && (
                            <span className="count">{selectedCategoryCheckboxes.length}</span>
                          )}
                        </span>
                      </span>
                      <DownFilterDown />
                    </span>

                    <span className={`filter-body ${showFilterId == "categoryOpen" ? "active" : ""} `}>
                      <form className=" app-search app-search1 d-flex justify-content-start ">
                        <div className="position-relative w-100">
                          <SearchesCIcon />
                          {searchFilter.length > 0 && (
                            <span className="searchiconcancel" onClick={() => setSearchFilter("")}>
                              <CancelIcon />
                            </span>
                          )}
                          <input
                            type="text"
                            name="searchName"
                            className="form-control"
                            placeholder={`Search ${categoryList?.name}`}
                            autoComplete="off"
                            value={searchFilter}
                            onChange={(e) => setSearchFilter(e.target.value)}
                          />
                        </div>
                      </form>
                      <div className="filter-list">
                        {!cateLoading ? (
                          categoryList?.children?.map((item) => {
                            if (searchFilter.length && !item.name.toLowerCase().includes(searchFilter)) return null;
                            const isChecked = selectedCategoryCheckboxes.some((checkbox) => checkbox.id === item.id);
                            return (
                              <div className="list-item" key={item.id}>
                                <div className="name-check">
                                  <FormGroup>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={isChecked}
                                          onClick={() => handleSelectCategory({id: item.id, name: item.name }, isChecked)}
                                        />
                                      }
                                    />
                                  </FormGroup>
                                  <p
                                    onClick={() => {
                                      item.children?.length > 0 && toggleExpand(item);
                                    }}
                                  >
                                    {item.name}
                                  </p>
                                </div>
                                {item.children?.length > 0 && (
                                  <div className="next" onClick={() => toggleExpand(item)}>
                                    <SideArrow />
                                  </div>
                                )}
                              </div>
                            );
                          })
                        ) : (
                          <>
                            {Array(4)
                              .fill(null)
                              .map((e) => {
                                return (
                                  <div className="list-item">
                                    <Skeleton width="95%" height="1.2rem" />
                                  </div>
                                );
                              })}
                          </>
                        )}
                      </div>
                    </span>
                  </div>

                  {optionList.map((e, i) => {
                    return (
                      <div className="filter-item" key={i}>
                        <span
                          className={showFilterId == e.id ? "filter-head active" : "filter-head "}
                          onClick={() => openFilter(e.id)}
                        >
                          <span className="arrow d-flex align-items-center justify-content-start gap-2">
                            <MyDashBoardIcon /> {e.name} {renderCount(e.id)}
                          </span>
                          <DownFilterDown />
                        </span>
                        <span className={showFilterId == e.id ? "filter-body active" : "filter-body"}>
                          <form className=" app-search app-search1 d-flex justify-content-start ">
                            <div className="position-relative w-100">
                              <SearchesCIcon />
                              {searchFilter.length > 0 && (
                                <span className="searchiconcancel" onClick={() => setSearchFilter("")}>
                                  <CancelIcon />
                                </span>
                              )}
                              <input
                                type="text"
                                name="searchName"
                                className="form-control"
                                placeholder={`Find ${e.name}`}
                                autoComplete="off"
                                value={searchFilter}
                                onChange={(e) => setSearchFilter(e.target.value)}
                              />
                            </div>
                          </form>

                          <div className="filter-list">
                            <FormGroup>
                              {e.tags.map((f, j) => {
                                if (searchFilter.length && !f.name.toLowerCase().includes(searchFilter)) return null;
                                const isChecked = selectedCheckboxes.some((item) => item.id === f.id);
                                return (
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={isChecked}
                                        onChange={() =>
                                          handleCheckboxChange({
                                            name: f.name,
                                            id: f.id,
                                          })
                                        }
                                      />
                                    }
                                    value={f.id}
                                    label={f.name}
                                  />
                                );
                              })}
                            </FormGroup>
                          </div>
                        </span>
                      </div>
                    );
                  })}

                  <div className="col-12 mt-4">
                    <button className="reset-btn" onClick={resetFilter}>
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-9 mt-2 px-4">
              <div className="col-12">
                <div className="temp" ref={parentRef}>
                  {shouldScroll && (
                    <div className="scroll-left" onClick={() => handleScroll("left")}>
                      <LeftArrow />
                    </div>
                  )}

                  <div className={shouldScroll ? "scrollable-filter after" : "scrollable-filter"} ref={containerRef}>
                    {configData.config.quickLinks.map((e, i) => {
                      let active = e.id.length
                        ? e.id.every((idB) => selectedQuickCheckboxes.some((objA) => objA.id === idB))
                        : false;
                      return (
                        <div className={active ? "active" : ""} onClick={() => quickSelect({ id: e.id, name: e.name })}>
                          <MyDashBoardIcon />
                          {e.name}
                        </div>
                      );
                    })}
                  </div>
                  {shouldScroll && (
                    <div className="scroll-right" nClick={() => handleScroll("right")}>
                      <RightArrow />
                    </div>
                  )}
                </div>
              </div>

              <div className="courses-explore">
                <CoursesCard list={exploreFilteredList} page="explore" loading={loading} />
              </div>
            </div>
          </div>
        </div>

        {showWalkThroughVideo && width > 776 && showTour && (
          <OnLoadSection setShowTour={setShowTour} showEndVideo={showEndVideo} />
        )}
      </div>
    </>
  );
};

export default ExploreCourses;
